export default "__VITE_ASSET__BiV7hWtH__"